export default [
  {
    id: '80f53559-4d3b-4a01-89b0-3e5d16d2ff0a',
    path: 'encode-rule',
    name: 'encode-rule',
    meta: { title: '信息对象解析' },
    children: [
      {
        id: '237be75b-b404-48db-b696-839c971158ef',
        path: 'attribute-rule-manage',
        name: 'attribute-rule-manage',
        component: (resolve) => {
          require(['../views/encodeRule/AttributeRuleManage'], resolve)
        },
        meta: {
          title: '对象属性解析规则',
          keepAlive: false,
          operations: {
            createAttr: {
              id: 0,
              name: 'createAttr',
              desc: '新增属性',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            createRule: {
              id: 5,
              name: 'createRule',
              desc: '新增规则',
              access: true,
            },
          },
        },
      },
      {
        id: '6140325f-ff25-4da6-b907-e0a2d5a39821',
        path: 'base-rule-manage',
        name: 'base-rule-manage',
        component: (resolve) => {
          require(['../views/encodeRule/baseRuleManage'], resolve)
        },
        meta: {
          title: '对象编码解析规则',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
          },
        },
      },
      {
        id: 'c6188f03-3c86-4f10-9a78-ad290ca6d324',
        path: 'task-type-management',
        name: 'task-type-management',
        component: (resolve) => {
          require(['../views/encodeRule/taskTypeManagement'], resolve)
        },
        meta: {
          title: '对象解析任务配置',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            open: {
              id: 1,
              name: 'open',
              desc: '开启',
              access: true,
            },
            stop: {
              id: 2,
              name: 'stop',
              desc: '停用',
              access: true,
            },
            update: {
              id: 3,
              name: 'update',
              desc: '编辑',
              access: true,
            },
          },
        },
      },
      {
        id: '044971e8-d316-4c30-960e-5b3660200413',
        path: 'background-task-management',
        name: 'background-task-management',
        component: (resolve) => {
          require(['../views/encodeRule/backgroundTaskManagement'], resolve)
        },
        meta: {
          title: '对象解析任务进度',
          keepAlive: false,
          operations: {
            delete: {
              id: 0,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            retry: {
              id: 1,
              name: 'retry',
              desc: '重试',
              access: true,
            },
            restore: {
              id: 2,
              name: 'restore',
              desc: '还原',
              access: true,
            },
          },
        },
      },
      {
        id: 'fe0526f8-cdce-4249-a391-a05dec33cbef',
        path: 'model-parse-tasks',
        name: 'model-parse-tasks',
        component: (resolve) => {
          require(['../views/encodeRule/ModelParseTasks'], resolve)
        },
        meta: {
          title: '模型解析任务',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            delete: {
              id: 1,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 2,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 3,
              name: 'import',
              desc: '导入',
              access: true,
            },
            update: {
              id: 4,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            manualExecution: {
              id: 5,
              name: 'manualExecution',
              desc: '手动执行',
              access: true,
            },
          },
        },
      },
      {
        id: '2cf70f3d-c96e-4997-98ff-cb59283335d4',
        path: 'model-parse-progress',
        name: 'model-parse-progress',
        component: (resolve) => {
          require(['../views/encodeRule/ModelParseProgress'], resolve)
        },
        meta: {
          title: '模型解析进度',
          keepAlive: false,
          operations: {
            delete: {
              id: 0,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '1621ce4c-c13e-4ded-bdd4-191c32741283',
        path: 'affiliations',
        name: 'affiliations',
        component: (resolve) => {
          require(['../views/encodeRule/Affiliations'], resolve)
        },
        meta: {
          title: '模型关联关系',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            delete: {
              id: 1,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 2,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 3,
              name: 'import',
              desc: '导入',
              access: true,
            },
          },
        },
      },
      {
        id: '70723508-07e4-4835-9beb-33603c50dc11',
        path: 'document-association-config',
        name: 'document-association-config',
        component: (resolve) => {
          require(['../views/encodeRule/documentAssociationConfig'], resolve)
        },
        meta: {
          title: '文档关联配置',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            delete: {
              id: 1,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 2,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 3,
              name: 'import',
              desc: '导入',
              access: true,
            },
          },
        },
      },
      {
        id: 'e0b887b8-e7d3-47e1-88c5-db737e4baa08',
        path: 'document-parse-progress',
        name: 'document-parse-progress',
        component: (resolve) => {
          require(['../views/encodeRule/documentParseProgress'], resolve)
        },
        meta: {
          title: '文档解析进度',
          keepAlive: false,
          operations: {
            delete: {
              id: 1,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: 'a1d87fa9-7815-4b05-b89b-3fc05c73132d',
        path: 'ocr-configure',
        name: 'ocr-configure',
        component: (resolve) => {
          require(['../views/encodeRule/OCRConfigure'], resolve)
        },
        meta: {
          title: 'OCR配置',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            delete: {
              id: 1,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
    ],
  },
]
